import formatDollar from "../../_src_shared/utils/functions/formatDollar";

/**
 * The DSCR workbook's P&I basis line, shared by the DSCR Calc. tab and the
 * DSCR Workbook strip so the two can't disagree
 * (dscr-calculator-workbook.md § Payment basis, 2026-10-05, EV30701).
 *
 *   amortizing: false → "interest-only · $712,500 @ 7.875%"
 *   amortizing: true  → "30-yr amortizing · $712,500 @ 7.875%"
 *
 * followed by the loan's `amortizationType` when it has one. The backend
 * decides the flag from the loan (Interest Only, 10yr IO / 20-Year Amortizing,
 * any IO period) — nothing is derived here.
 */

/**
 * `interestRate` on the workbook is a decimal fraction (0.07875 → "7.875%").
 * A value above 1 is treated as already a percent, so a whole-number rate
 * from elsewhere can't print as 787.5%.
 */
export const formatDscrRate = (rate, fallback = "—") => {
  if (rate == null || rate === "") return fallback;
  const n = Number(rate);
  if (!Number.isFinite(n)) return fallback;
  const pct = Math.abs(n) <= 1 ? n * 100 : n;
  return `${Number(pct.toFixed(3))}%`;
};

export const dscrPaymentBasisLabel = (calc, amortizationType) => {
  const basis = calc?.amortizing === false ? "interest-only" : "30-yr amortizing";
  const parts = [basis];
  if (calc?.loanAmount != null) {
    parts.push(
      `${formatDollar(calc.loanAmount)}${
        calc?.interestRate != null ? ` @ ${formatDscrRate(calc.interestRate)}` : ""
      }`,
    );
  } else if (calc?.interestRate != null) {
    parts.push(`@ ${formatDscrRate(calc.interestRate)}`);
  }
  if (amortizationType) parts.push(amortizationType);
  return parts.join(" · ");
};
